
const DIVISION_MAP = {
  infrastructure: 'Infrastructure',
  publicBuilding: 'Public Buildings',
};

const GROUP_MAP = {
  1: 1,
  2: 2,
};

export function titleOptionsForDivision (projectTitles, divisionName, groupName) {
  return projectTitles.filter(({ division, group }) => {
    return (DIVISION_MAP[division] === divisionName) && (GROUP_MAP[group] === groupName);
  }).map(role => {
    return { label: role.title, value: role.id }
  });
}

export function isActiveEmployee(employee) {
  if (employee === undefined)
    return undefined;
  if (employee.eStatus === 'B')
    return true;
  if (employee.loginId.toLowerCase().startsWith('ct'))
    return null;  // Unknown
  else return false;
  }
